import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { mapPickem } from "db/mapping/pickem/FsPickem";
import { FsPickem } from "db/model/pickem/FsPickem";
import { Pickem } from "model/Pickem/Pickem";

export interface IUserSlice {
  uid: string;
  username: string;
  groups: string[];
  pickems: { [key: string]: Pickem };
}

const initialState: IUserSlice = {
  uid: "",
  username: "",
  groups: [],
  pickems: {},
};

// todo - deal with clearing data and subscriptions properly, e.g. if change user can probably access old pickems and see changes still
export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (
      state,
      action: PayloadAction<{
        uid: string;
        username: string;
        groups: string[];
      }>
    ) => {
      const { uid, username, groups } = action.payload;
      state.uid = uid;
      state.username = username;
      state.groups = groups;
    },
    updatePickem: (
      state,
      action: PayloadAction<{ id: string; data: FsPickem }>
    ) => {
      const { id, data } = action.payload;
      const mappedPickem = mapPickem(data);
      if (!!mappedPickem) {
        state.pickems[id] = mappedPickem;
      }
    },
    resetUser: (state) => {
      state.uid = "";
      state.username = "";
      state.groups = [];
      state.pickems = {};
    },
  },
});

export const { setUser, resetUser, updatePickem } = userSlice.actions;

export const userReducer = userSlice.reducer;
